var render, staticRenderFns
import script from "./ErrorPageWrapper.vue?vue&type=script&lang=js&"
export * from "./ErrorPageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6306ce16')) {
      api.createRecord('6306ce16', component.options)
    } else {
      api.reload('6306ce16', component.options)
    }
    
  }
}
component.options.__file = "src/views/ErrorPageWrapper.vue"
export default component.exports